import { useState } from 'react'

import notification from 'common/components/feedback/Notification'

export type CommandResponse<T> = {
  errors: string[]
  data: T | null
  hasErrors: boolean
  completed: boolean
}

const ok = <T>(data: any): CommandResponse<T> => {
  return {
    errors: [],
    hasErrors: false,
    data,
    completed: true,
  }
}

const badRequest = <T>(errors: []): CommandResponse<T> => {
  return {
    errors,
    hasErrors: true,
    data: null,
    completed: false,
  }
}

export type SendCommandRequestOptions = {
  showErrors: boolean
}

/**
 * @deprecated The method should not be used. Please use useCommandRequestV2 instead.
 */
export default <T>(): [
  (func: () => Promise<T>, opts?: SendCommandRequestOptions) => Promise<CommandResponse<T>>,
  boolean,
] => {
  const [isLoading, setIsLoading] = useState(false)

  const sendCommandRequest = async (
    func: () => Promise<T>,
    opts?: SendCommandRequestOptions,
  ): Promise<CommandResponse<T>> => {
    try {
      setIsLoading(true)
      const result = await func()
      setIsLoading(false)
      return ok(result)
    } catch (err) {
      setIsLoading(false)
      const displayErrors = !opts || opts.showErrors

      if (err && err.status === 401) {
        ;(window.location as any) = '/login'
        return badRequest<any>([])
      }

      if (err && err.status === 400) {
        let errors = []
        try {
          errors = err.data.map((x: any) => x.message)
        } catch (e) {}

        if (displayErrors) {
          notification.error(errors.join(','))
        }
        return badRequest<any>(errors as any)
      }

      if (displayErrors) {
        await notification.error('An error occurred while processing your request')
      }

      return badRequest([])
    }
  }

  return [sendCommandRequest, isLoading]
}
